import { FieldValues, SubmitErrorHandler, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { HookFormCustomParams } from '../types';
import { CorrelationCheckErrors, ListCorrelationErrors } from './CorrelationCheckErrors';
import { setErrorsHanlder } from './setErrorsHanlder';

export const handlerSubmitHandler =
  <TFieldValues extends FieldValues, TContext = ControlledType>(
    form: UseFormReturn<TFieldValues>,
    props: HookFormCustomParams<TFieldValues, TContext>
  ) =>
  (onValid: SubmitHandler<TFieldValues>, onInvalid?: SubmitErrorHandler<TFieldValues>) =>
    form.handleSubmit((values: TFieldValues) => {
      const correlationCheck = new CorrelationCheckErrors<TFieldValues>();
      const validation = props?.validationSubmission?.(values, correlationCheck);
      if (validation && validation.hasError()) {
        const allErrors: ListCorrelationErrors[] = validation.getFieldErrors();
        setErrorsHanlder(form)(allErrors);
        return null;
      }

      return onValid(values);
    }, onInvalid);
